export const REQUEST_TEXT_STATUS = {
  create: {
    success: {
      title: "Banner Created Successfully!",
      description: "Banner information is successfully created and saved",
      status: "success",
      duration: 9000,
      isClosable: true,
      position: "bottom-left",
    },
    error: {
      title: "Banner Creation Failed!",
      description: "Unable to create the banner information.",
      status: "error",
      duration: 9000,
      isClosable: true,
      position: "bottom-left",
    },
  },
  update: {
    success: {
      title: "Banner Updated Successfully!",
      description: "Banner information is successfully updated",
      status: "success",
      duration: 9000,
      isClosable: true,
      position: "bottom-left",
    },
    error: {
      title: "Banner Update Failed!",
      description: "Unable to update the banner information.",
      status: "error",
      duration: 9000,
      isClosable: true,
      position: "bottom-left",
    },
  },
  delete: {
    success: {
      title: "Banner Deleted Successfully!",
      description: "Banner information is successfully deleted",
      status: "success",
      duration: 9000,
      isClosable: true,
      position: "bottom-left",
    },
    error: {
      title: "Banner Delete Failed!",
      description: "Unable to delete the banner information.",
      status: "error",
      duration: 9000,
      isClosable: true,
      position: "bottom-left",
    },
  },
};

export const TEXT_DIALOG = {
  create: {
    header: "Create New Banner",
    body: "Proceed to create the banner? You can only update banner name and image.",
    confirm: "Confirm Create",
    button_color: "green.500",
  },
  update: {
    header: "Update Banner Information",
    body: "Proceed to update the information on the banner?",
    confirm: "Confirm Update",
    button_color: "#897502",
  },
  delete: {
    header: "Delete Banner Information",
    body: "Proceed to delete the information on the banner?",
    confirm: "Confirm Delete",
    button_color: "red",
  },
};

export const BANNER_STATE = {
  error: {
    title: "Reading Banner Data Failed!",
    description: "Unable to get the banner data from state, possibly due to time-out ...",
    status: "error",
    duration: 9000,
    isClosable: true,
    position: "bottom-left",
  },
};
